module.exports = __webpack_public_path__ + "static/homepage-screenshot-9255511735e0d045fa00c247ee787cbd.png";